import { render } from "./busquedaavanzada2.vue?vue&type=template&id=325686da&scoped=true"
import script from "./busquedaavanzada2.vue?vue&type=script&lang=js"
export * from "./busquedaavanzada2.vue?vue&type=script&lang=js"

import "./busquedaavanzada2.vue?vue&type=style&index=0&id=325686da&scoped=true&lang=css"

import exportComponent from "C:\\HAZAKPUEBLA\\cedispage2.0jacve\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-325686da"]])

export default __exports__